import { defineComponent as $, useAttrs as j, computed as p, openBlock as z, createElementBlock as B, normalizeProps as E, guardReactiveProps as P } from "vue";
var T = (e, r) => {
  if (!(!e || !r))
    switch (r) {
      // If screen is wider than the max size, image width is the max size,
      // otherwise it's the width of the screen
      case "constrained":
        return `(min-width: ${e}px) ${e}px, 100vw`;
      // Image is always the same width, whatever the size of the screen
      case "fixed":
        return `${e}px`;
      // Image is always the width of the screen
      case "fullWidth":
        return "100vw";
      default:
        return;
    }
}, m = (e) => e || e === 0 ? `${e}px` : void 0, w = ({
  width: e,
  height: r,
  aspectRatio: i,
  layout: n,
  objectFit: s = "cover",
  background: t
}) => {
  const o = [
    ["object-fit", s]
  ];
  return t != null && t.startsWith("https:") || t != null && t.startsWith("http:") || t != null && t.startsWith("data:") || t != null && t.startsWith("/") ? (o.push(["background-image", `url(${t})`]), o.push(["background-size", "cover"]), o.push(["background-repeat", "no-repeat"])) : o.push(["background", t]), n === "fixed" && (o.push(["width", m(e)]), o.push(["height", m(r)])), n === "constrained" && (o.push(["max-width", m(e)]), o.push(["max-height", m(r)]), o.push([
    "aspect-ratio",
    i ? `${i}` : void 0
  ]), o.push(["width", "100%"])), n === "fullWidth" && (o.push(["width", "100%"]), o.push([
    "aspect-ratio",
    i ? `${i}` : void 0
  ]), o.push(["height", m(r)])), Object.fromEntries(
    o.filter(([, a]) => a)
  );
}, F = [
  6016,
  // 6K
  5120,
  // 5K
  4480,
  // 4.5K
  3840,
  // 4K
  3200,
  // QHD+
  2560,
  // WQXGA
  2048,
  // QXGA
  1920,
  // 1080p
  1668,
  // Various iPads
  1280,
  // 720p
  1080,
  // iPhone 6-8 Plus
  960,
  // older horizontal phones
  828,
  // iPhone XR/11
  750,
  // iPhone 6-8
  640
  // older and lower-end phones
], y = 24, H = ({
  width: e,
  layout: r,
  resolutions: i = F
}) => {
  if (r === "fullWidth")
    return i;
  if (!e)
    return [];
  const n = e * 2;
  return r === "fixed" ? [e, n] : r === "constrained" ? [
    // Always include the image at 1x and 2x the specified width
    e,
    n,
    // Filter out any resolutions that are larger than the double-res image
    ...i.filter((s) => s < n)
  ] : [];
}, L = ({
  src: e,
  width: r,
  layout: i = "constrained",
  height: n,
  aspectRatio: s,
  breakpoints: t,
  format: o
}) => (t || (t = H({ width: r, layout: i })), t.sort((a, f) => a - f).map((a) => {
  let f;
  return n && s && (f = Math.round(a / s)), {
    url: e,
    width: a,
    height: f,
    format: o
  };
})), I = (e) => {
  let { src: r, transformer: i, operations: n } = e;
  return i ? L(e).map(({ url: s, ...t }) => {
    const o = i(
      r,
      { ...n, ...t },
      e.options
    );
    return `${o == null ? void 0 : o.toString()} ${t.width}w`;
  }).join(`,
`) : "";
};
function O({
  width: e,
  height: r,
  priority: i,
  layout: n = "constrained",
  aspectRatio: s,
  ...t
}) {
  return e = e && Number(e) || void 0, r = r && Number(r) || void 0, i ? (t.loading || (t.loading = "eager"), t.fetchpriority || (t.fetchpriority = "high")) : (t.loading || (t.loading = "lazy"), t.decoding || (t.decoding = "async")), t.alt === "" && (t.role || (t.role = "presentation")), s ? e ? r || (r = Math.round(e / s)) : r && (e = Math.round(r * s)) : e && r && (s = e / r), {
    width: e,
    height: r,
    aspectRatio: s,
    layout: n,
    ...t
  };
}
function N(e) {
  let {
    src: r,
    transformer: i,
    background: n,
    layout: s,
    objectFit: t,
    breakpoints: o,
    width: a,
    height: f,
    aspectRatio: c,
    unstyled: h,
    operations: S,
    options: d,
    ...u
  } = O(e);
  if (i && n === "auto") {
    const l = c ? Math.round(y / c) : void 0, _ = i(
      r,
      {
        width: y,
        height: l
      },
      d
    );
    _ && (n = _.toString());
  }
  const v = {
    width: a,
    height: f,
    aspectRatio: c,
    layout: s,
    objectFit: t,
    background: n
  };
  if (u.sizes || (u.sizes = T(a, s)), h || (u.style = {
    ...w(v),
    ...u.style
  }), i) {
    u.srcset = I({
      src: r,
      width: a,
      height: f,
      aspectRatio: c,
      layout: s,
      breakpoints: o,
      transformer: i,
      operations: S,
      options: d
    });
    const l = i(
      r,
      { ...S, width: a, height: f },
      d
    );
    l && (r = l), (s === "fullWidth" || s === "constrained") && (a = void 0, f = void 0);
  }
  return {
    ...u,
    src: r == null ? void 0 : r.toString(),
    width: a,
    height: f
  };
}
function A(e) {
  return e ? e.startsWith("image/") ? {
    format: e.slice(6),
    mimeType: e
  } : {
    format: e,
    mimeType: `image/${e === "jpg" ? "jpeg" : e}`
  } : {};
}
function D({
  media: e,
  type: r,
  ...i
}) {
  let {
    src: n,
    transformer: s,
    layout: t,
    breakpoints: o,
    width: a,
    height: f,
    aspectRatio: c,
    sizes: h,
    loading: S,
    decoding: d,
    operations: u,
    options: v,
    ...l
  } = O(i);
  if (!s)
    return {};
  const { format: _, mimeType: x } = A(r);
  h || (h = T(a, t));
  const M = I({
    src: n,
    width: a,
    height: f,
    aspectRatio: c,
    layout: t,
    breakpoints: o,
    transformer: s,
    format: _,
    operations: u,
    options: v
  }), W = s(
    n,
    { ...u, width: a, height: f },
    v
  );
  W && (n = W);
  const g = {
    ...l,
    sizes: h,
    srcset: M
  };
  return e && (g.media = e), x && (g.type = x), g;
}
const C = /* @__PURE__ */ $({
  __name: "image",
  props: {
    src: {},
    width: {},
    height: {},
    layout: {},
    priority: { type: Boolean },
    background: {},
    aspectRatio: {},
    objectFit: {},
    unstyled: { type: Boolean },
    transformer: {},
    operations: {},
    options: {}
  },
  setup(e) {
    const r = e, i = j(), n = p(
      () => N({
        ...i,
        ...r
      })
    );
    return (s, t) => (z(), B("img", E(P(n.value)), null, 16));
  }
}), R = /* @__PURE__ */ $({
  __name: "source",
  props: {
    src: {},
    width: {},
    height: {},
    layout: {},
    cdn: {},
    fallback: {},
    aspectRatio: {},
    transformer: {},
    operations: {},
    options: {}
  },
  setup(e) {
    const r = e, i = j(), n = p(
      () => D({
        ...i,
        ...r
      })
    );
    return (s, t) => (z(), B("source", E(P(n.value)), null, 16));
  }
});
export {
  C as Image,
  R as Source
};
